const word = ['docx', 'doc'];
const pdf = ['pdf'];
const excel = ['xlsx', 'xlsm', 'xls', 'xml'];

export { word, pdf, excel };
